/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Video_Export_Export_Preset_SavedInputs */



/**
* | output |
* | --- |
* | "Video export preset \"{name}\" saved successfully" |
*
* @param {Video_Export_Export_Preset_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_saved = /** @type {((inputs: Video_Export_Export_Preset_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Prereglage d'exportation video "${i?.name}" enregistre avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Videoexportvorgabe "${i?.name}" erfolgreich gespeichert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Preimpostazione di esportazione video "${i?.name}" salvata correttamente`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Настройки экспорта видео "${i?.name}" успешно сохранены.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El ajuste preestablecido de exportación de video "${i?.name}" se guardó correctamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`视频导出预设“${i?.name}”已成功保存`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオエクスポートプリセット「${i?.name}」が正常に保存されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो निर्यात प्रीसेट "${i?.name}" सफलतापूर्वक सहेज लिया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A predefinição de exportação de vídeo "${i?.name}" foi salva com sucesso.`)
	return /** @type {LocalizedString} */ (`Video export preset "${i?.name}" saved successfully`)
});